// src/pages/logistica/Otif.jsx
import { useEffect, useState } from 'react';
import api from '../../services/api';

export default function Otif() {
  const [nivel, setNivel] = useState('linea'); // 'linea' | 'oc'
  const [semanal, setSemanal] = useState([]);
  const [semanaSeleccionada, setSemanaSeleccionada] = useState(null);
  const [porCliente, setPorCliente] = useState([]);
  const [semanaMostrada, setSemanaMostrada] = useState(null);
  const [clienteExpandido, setClienteExpandido] = useState(null);
  const [lineasCliente, setLineasCliente] = useState([]);
  const [cargandoLineas, setCargandoLineas] = useState(false);
  const [cargando, setCargando] = useState(true);
  const [sincronizando, setSincronizando] = useState(false);
  const [mensaje, setMensaje] = useState(null);
  const [rangoDesde, setRangoDesde] = useState('');
  const [rangoHasta, setRangoHasta] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const [resultadosBusqueda, setResultadosBusqueda] = useState(null);
  const [buscando, setBuscando] = useState(false);

  async function cargarSemanal() {
    const endpoint = nivel === 'linea' ? '/api/logistica/otif/semanal' : '/api/logistica/otif/ordenes-semanal';
    const params = rangoDesde && rangoHasta ? { desde: rangoDesde, hasta: rangoHasta } : { semanas: 12 };
    const res = await api.get(endpoint, { params });
    setSemanal(res.data.data);
  }

  async function cargarPorCliente(semana) {
    const res = await api.get('/api/logistica/otif/por-cliente', semana ? { params: { semana } } : {});
    setPorCliente(res.data.data);
    setSemanaMostrada(res.data.semana);
  }

  async function cargarTodo() {
    try {
      setCargando(true);
      await Promise.all([cargarSemanal(), cargarPorCliente(semanaSeleccionada)]);
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargarTodo(); }, [nivel]); // eslint-disable-line

  async function handleClickSemana(semana) {
    setClienteExpandido(null);
    setSemanaSeleccionada(semana);
    setCargando(true);
    try {
      await cargarPorCliente(semana);
    } finally {
      setCargando(false);
    }
  }

  async function handleBuscarRango() {
    if (!rangoDesde || !rangoHasta) return;
    setCargando(true);
    try {
      await cargarSemanal();
    } finally {
      setCargando(false);
    }
  }

  async function handleLimpiarRango() {
    setRangoDesde('');
    setRangoHasta('');
    setCargando(true);
    try {
      await cargarSemanal();
    } finally {
      setCargando(false);
    }
  }

  async function handleClickCliente(cliente) {
    if (clienteExpandido === cliente) {
      setClienteExpandido(null);
      return;
    }
    setClienteExpandido(cliente);
    try {
      setCargandoLineas(true);
      const res = await api.get('/api/logistica/otif/lineas', { params: { semana: semanaMostrada, cliente } });
      setLineasCliente(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setCargandoLineas(false);
    }
  }

  async function handleBuscar() {
    if (!busqueda.trim()) return;
    try {
      setBuscando(true);
      const res = await api.get('/api/logistica/otif/buscar', { params: { q: busqueda.trim() } });
      setResultadosBusqueda(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setBuscando(false);
    }
  }

  function handleLimpiarBusqueda() {
    setBusqueda('');
    setResultadosBusqueda(null);
  }

  async function handleSincronizar() {
    try {
      setSincronizando(true);
      setMensaje(null);
      await api.post('/api/logistica/otif/sync');
      await cargarTodo();
      setMensaje({ tipo: 'ok', texto: '✓ Sincronizado con NetSuite.' });
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: 'No se pudo sincronizar.' });
    } finally {
      setSincronizando(false);
    }
  }

  const totalKey = nivel === 'linea' ? 'lineas' : 'ordenes';
  const otifKey = nivel === 'linea' ? 'lineas_otif' : 'ordenes_otif';
  const sinDatoKey = nivel === 'linea' ? 'lineas_sin_dato' : 'ordenes_sin_dato';

  if (cargando && semanal.length === 0 && resultadosBusqueda === null) return <div style={styles.contenedor}>Cargando...</div>;

  return (
    <div style={styles.contenedor} className="contenedor-captura">
      <div style={styles.encabezado}>
        <div>
          <h1 style={styles.titulo}>OTIF — On Time In Full</h1>
          <p style={styles.subtitulo}>Entregas completas y a tiempo (Fecha de Entrega al Cliente ≤ Fecha Venc. OC, o la fecha reagendada si aplica).</p>
        </div>
        <button onClick={handleSincronizar} disabled={sincronizando} style={styles.botonSync}>
          {sincronizando ? 'Sincronizando...' : '↻ Sincronizar con NetSuite'}
        </button>
      </div>

      <div style={styles.avisoSinDato}>
        ⚠ Las líneas marcadas <strong>"sin registrar"</strong> no tienen Fecha de Entrega al Cliente capturada en NetSuite — no sabemos si llegaron a tiempo o no, así que cuentan aparte del % de OTIF real hasta que se capture esa fecha consistentemente.
      </div>

      <div style={styles.toggleNivel}>
        <button onClick={() => setNivel('linea')} style={{ ...styles.botonToggle, ...(nivel === 'linea' ? styles.botonToggleActivo : {}) }}>Por línea</button>
        <button onClick={() => setNivel('oc')} style={{ ...styles.botonToggle, ...(nivel === 'oc' ? styles.botonToggleActivo : {}) }}>Por OC completa</button>
      </div>

      <div style={styles.cajaBusqueda}>
        <input
          type="text"
          placeholder="Buscar por Num OC o Cliente…"
          value={busqueda}
          onChange={(e) => setBusqueda(e.target.value)}
          onKeyDown={(e) => e.key === 'Enter' && handleBuscar()}
          style={styles.inputBusqueda}
        />
        <button onClick={handleBuscar} disabled={buscando || !busqueda.trim()} style={styles.botonBuscar}>
          {buscando ? 'Buscando...' : 'Buscar'}
        </button>
        {resultadosBusqueda !== null && (
          <button onClick={handleLimpiarBusqueda} style={styles.botonQuitarFiltro}>quitar búsqueda</button>
        )}
      </div>

      {mensaje && <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>{mensaje.texto}</div>}

      {resultadosBusqueda !== null ? (
        <div style={styles.tarjeta}>
          <div style={styles.seccionTitulo}>Resultados de búsqueda ({resultadosBusqueda.length})</div>
          {resultadosBusqueda.length === 0 ? (
            <p style={{ color: '#8A7690', fontSize: '12px' }}>Sin resultados para "{busqueda}".</p>
          ) : (
             <div className="tabla-scroll">
              <table style={styles.tabla}>
                <thead>
                  <tr>
                    <th style={styles.th}>Num OC</th>
                    <th style={styles.th}>Cliente</th>
                    <th style={styles.th}>Artículo</th>
                    <th style={styles.th}>Vence</th>
                    <th style={styles.th}>Entregado</th>
                    <th style={styles.thCentro}>En Full</th>
                    <th style={styles.thCentro}>A Tiempo</th>
                    <th style={styles.thCentro}>OTIF</th>
                  </tr>
                </thead>
                <tbody>
                  {resultadosBusqueda.map((r, idx) => (
                    <tr key={idx} style={r.sin_fecha_registrada ? styles.filaSinDato : {}}>
                      <td style={styles.td}>{r.numero_oc}</td>
                      <td style={styles.td}>{r.cliente}</td>
                      <td style={styles.td}>{r.articulo}</td>
                      <td style={styles.td}>
                        {r.fecha_venc_oc ? new Date(r.fecha_venc_oc).toLocaleDateString('es-MX') : '—'}
                        {r.cita_reagendada && r.fecha_cita_reagendada && (
                          <div style={styles.notaReagendada}>↻ reagendada a {new Date(r.fecha_cita_reagendada).toLocaleDateString('es-MX')}</div>
                        )}
                      </td>
                      <td style={styles.td}>{r.fecha_entrega_cliente ? new Date(r.fecha_entrega_cliente).toLocaleDateString('es-MX') : <span style={styles.tagSinDato}>sin registrar</span>}</td>
                      <td style={{ ...styles.tdCentro, color: r.en_full ? '#3E7C5A' : '#B23A48' }}>{r.en_full ? '✓' : '✗'}</td>
                      <td style={styles.tdCentro}>{r.sin_fecha_registrada ? '—' : <span style={{ color: r.a_tiempo ? '#3E7C5A' : '#B23A48' }}>{r.a_tiempo ? '✓' : '✗'}</span>}</td>
                      <td style={styles.tdCentro}>{r.sin_fecha_registrada ? <span style={styles.tagSinDato}>sin dato</span> : <span style={{ fontWeight: 700, color: r.otif ? '#3E7C5A' : '#B23A48' }}>{r.otif ? '✓' : '✗'}</span>}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>  
          )}
        </div>
      ) : (
        <>
          <div style={styles.tarjeta}>
            <div style={styles.seccionTitulo}>
              {rangoDesde && rangoHasta ? `${semanal.length} semanas en el rango` : `Últimas ${semanal.length} semanas`} — {nivel === 'linea' ? 'por línea' : 'por OC completa'}
            </div>
            <div style={styles.filtroFechas}>
              <input type="date" value={rangoDesde} onChange={(e) => setRangoDesde(e.target.value)} style={styles.inputFecha} />
              <span style={{ color: '#8A7690', fontSize: '12px' }}>a</span>
              <input type="date" value={rangoHasta} onChange={(e) => setRangoHasta(e.target.value)} style={styles.inputFecha} />
              <button onClick={handleBuscarRango} disabled={!rangoDesde || !rangoHasta} style={styles.botonBuscar}>Buscar</button>
              {rangoDesde && rangoHasta && (
                <button onClick={handleLimpiarRango} style={styles.botonQuitarFiltro}>últimas 12 semanas</button>
              )}
            </div>
            {semanal.length === 0 && <p style={{ color: '#8A7690', fontSize: '12px' }}>Sin datos aún — sincroniza primero.</p>}
            <div style={styles.historicoTabla}>
              {semanal.map((s) => {
                const activa = semanaMostrada && new Date(s.semana).toDateString() === new Date(semanaMostrada).toDateString();
                return (
                  <div
                    key={s.semana}
                    onClick={() => handleClickSemana(s.semana)}
                    style={{ ...styles.historicoFila, ...(activa ? styles.historicoFilaActiva : {}) }}
                  >
                    <span style={styles.historicoFecha}>{new Date(s.semana).toLocaleDateString('es-MX', { day: '2-digit', month: 'short' })}</span>
                    <div style={styles.barraFondo}>
                      <div style={{ ...styles.barraLlena, width: `${Math.min(s.pct_otif, 100)}%`, background: s.pct_otif >= 95 ? '#3E7C5A' : s.pct_otif >= 85 ? '#D6A644' : '#B23A48' }} />
                    </div>
                    <span style={styles.historicoPct}>{s.pct_otif}%</span>
                    <span style={styles.historicoSinDato}>{s.pct_sin_dato}% sin dato</span>
                    <span style={styles.historicoLineas}>{s[totalKey]} {nivel === 'linea' ? 'líneas' : 'OCs'}</span>
                  </div>
                );
              })}
            </div>
          </div>

          <div style={styles.tarjeta}>
            <div style={styles.seccionTitulo}>
              Por cliente {semanaMostrada && `— semana del ${new Date(semanaMostrada).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })}`}
              {semanaSeleccionada && (
                <button onClick={() => handleClickSemana(null)} style={styles.botonQuitarFiltro}>ver semana más reciente</button>
              )}
            </div>
            {porCliente.length === 0 && <p style={{ color: '#8A7690', fontSize: '12px' }}>Sin datos para esta semana.</p>}
            <div className="tabla-scroll">
              <table style={styles.tabla}>
                <thead>
                  <tr>
                    <th style={styles.th}>Cliente</th>
                    <th style={styles.thNum}>Líneas</th>
                    <th style={styles.thNum}>OTIF</th>
                    <th style={styles.thNum}>% OTIF</th>
                    <th style={styles.thNum}>% Sin dato</th>
                  </tr>
                </thead>
                <tbody>
                  {porCliente.map((c) => (
                    <>
                      <tr key={c.cliente} onClick={() => handleClickCliente(c.cliente)} style={styles.filaClickable}>
                        <td style={styles.td}>
                          <span style={styles.flechaExpandir}>{clienteExpandido === c.cliente ? '▾' : '▸'}</span> {c.cliente}
                        </td>
                        <td style={styles.tdNum}>{c.lineas}</td>
                        <td style={styles.tdNum}>{c.lineas_otif}</td>
                        <td style={{ ...styles.tdNum, fontWeight: 700, color: c.pct_otif >= 95 ? '#3E7C5A' : c.pct_otif >= 85 ? '#B8862E' : '#B23A48' }}>
                          {c.pct_otif}%
                        </td>
                        <td style={{ ...styles.tdNum, color: c.pct_sin_dato > 0 ? '#B8862E' : '#8A7690' }}>{c.pct_sin_dato}%</td>
                      </tr>
                      {clienteExpandido === c.cliente && (
                        <tr key={`${c.cliente}-detalle`}>
                          <td colSpan={5} style={styles.celdaDetalle}>
                            {cargandoLineas ? (
                              <span style={{ fontSize: '11.5px', color: '#8A7690' }}>Cargando líneas...</span>
                            ) : (
                              <table style={styles.tablaDetalle}>
                                <thead>
                                  <tr>
                                    <th style={styles.thDetalle}>Num OC</th>
                                    <th style={styles.thDetalle}>Artículo</th>
                                    <th style={styles.thNumDetalle}>Solicitado</th>
                                    <th style={styles.thNumDetalle}>Facturado</th>
                                    <th style={styles.thCentroDetalle}>En Full</th>
                                    <th style={styles.thCentroDetalle}>A Tiempo</th>
                                    <th style={styles.thCentroDetalle}>OTIF</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {lineasCliente.map((l, idx) => (
                                    <tr key={idx} style={l.sin_fecha_registrada ? styles.filaSinDato : (!l.otif ? styles.filaDetalleFalla : {})}>
                                      <td style={styles.tdDetalle}>{l.numero_oc}</td>
                                      <td style={styles.tdDetalle}>{l.articulo}</td>
                                      <td style={styles.tdNumDetalle}>{Number(l.cantidad_solicitada).toLocaleString('es-MX')}</td>
                                      <td style={styles.tdNumDetalle}>{Number(l.cantidad_facturada).toLocaleString('es-MX')}</td>
                                      <td style={{ ...styles.tdCentroDetalle, color: l.en_full ? '#3E7C5A' : '#B23A48' }}>{l.en_full ? '✓' : '✗'}</td>
                                      <td style={styles.tdCentroDetalle}>
                                        {l.sin_fecha_registrada
                                          ? <span style={styles.tagSinDato}>sin registrar</span>
                                          : <span style={{ color: l.a_tiempo ? '#3E7C5A' : '#B23A48' }}>{l.a_tiempo ? '✓' : '✗'}</span>}
                                      </td>
                                      <td style={styles.tdCentroDetalle}>
                                        {l.sin_fecha_registrada
                                          ? <span style={styles.tagSinDato}>sin dato</span>
                                          : <span style={{ fontWeight: 700, color: l.otif ? '#3E7C5A' : '#B23A48' }}>{l.otif ? '✓' : '✗'}</span>}
                                      </td>
                                    </tr>
                                  ))}
                                </tbody>
                              </table>
                            )}
                          </td>
                        </tr>
                      )}
                    </>
                  ))}
                </tbody>
              </table>
            </div>   
          </div>
        </>
      )}
    </div>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42', maxWidth: '920px' },
  encabezado: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '14px', marginBottom: '4px', flexWrap: 'wrap' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '2px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', maxWidth: '480px' },
  botonSync: { flexShrink: 0, padding: '9px 14px', fontSize: '12px', fontWeight: 600, color: '#fff', background: '#6A2C75', border: 'none', borderRadius: '8px', cursor: 'pointer', whiteSpace: 'nowrap' },
  avisoSinDato: { fontSize: '11.5px', color: '#8A7300', background: '#FBF6E9', border: '1px solid #E8D48A', borderRadius: '8px', padding: '10px 14px', margin: '12px 0' },
  toggleNivel: { display: 'flex', gap: '6px', margin: '6px 0 6px' },
  botonToggle: { padding: '7px 14px', fontSize: '12px', fontWeight: 600, color: '#6E4F80', background: '#EFE9F3', border: '1px solid #A98BB8', borderRadius: '20px', cursor: 'pointer' },
  botonToggleActivo: { background: '#6A2C75', color: '#fff', borderColor: '#6A2C75' },
  mensaje: { fontSize: '13px', margin: '10px 0', fontWeight: 600 },
  cajaBusqueda: { display: 'flex', gap: '8px', alignItems: 'center', margin: '10px 0', flexWrap: 'wrap' },
  inputBusqueda: { flex: 1, maxWidth: '380px', padding: '9px 12px', fontSize: '13px', border: '1px solid #D6A644', borderRadius: '8px', fontFamily: 'Inter, sans-serif', background: '#FFFDF7' },
  botonBuscar: { padding: '6px 14px', fontSize: '12px', fontWeight: 600, color: '#fff', background: '#6A2C75', border: 'none', borderRadius: '6px', cursor: 'pointer' },
  botonQuitarFiltro: { fontSize: '10.5px', fontWeight: 600, color: '#6A2C75', background: '#EFE9F3', border: '1px solid #A98BB8', borderRadius: '12px', padding: '3px 10px', cursor: 'pointer', marginLeft: '10px' },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '18px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)', marginTop: '10px' },
  seccionTitulo: { fontSize: '13px', fontWeight: 700, color: '#2A1830', marginBottom: '12px', display: 'flex', alignItems: 'center' },
  filtroFechas: { display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '14px', flexWrap: 'wrap' },
  inputFecha: { padding: '6px 8px', fontSize: '12px', border: '1px solid #D6A644', borderRadius: '6px', fontFamily: 'Inter, sans-serif', background: '#FFFDF7' },
  historicoTabla: { display: 'flex', flexDirection: 'column', gap: '4px' },
  historicoFila: { display: 'flex', alignItems: 'center', gap: '10px', padding: '4px 6px', borderRadius: '6px', cursor: 'pointer' },
  historicoFilaActiva: { background: '#F5F0F7', outline: '1px solid #A98BB8' },
  historicoFecha: { fontSize: '11px', color: '#8A7690', width: '50px', flexShrink: 0 },
  barraFondo: { flex: 1, height: '10px', background: '#F0E9E0', borderRadius: '6px', overflow: 'hidden' },
  barraLlena: { height: '100%', borderRadius: '6px' },
  historicoPct: { fontSize: '11px', fontWeight: 700, width: '40px', textAlign: 'right' },
  historicoSinDato: { fontSize: '10px', color: '#B8862E', width: '80px', textAlign: 'right' },
  historicoLineas: { fontSize: '10px', color: '#8A7690', width: '60px', textAlign: 'right' },
  tabla: { width: '100%', borderCollapse: 'collapse', fontSize: '12.5px' },
  th: { textAlign: 'left', padding: '8px 10px', color: '#8A7690', fontSize: '11px', textTransform: 'uppercase', borderBottom: '2px solid #E6DDD2' },
  thNum: { textAlign: 'right', padding: '8px 10px', color: '#8A7690', fontSize: '11px', textTransform: 'uppercase', borderBottom: '2px solid #E6DDD2' },
  thCentro: { textAlign: 'center', padding: '8px 10px', color: '#8A7690', fontSize: '11px', textTransform: 'uppercase', borderBottom: '2px solid #E6DDD2' },
  td: { padding: '7px 10px', borderBottom: '1px solid #F0E9E0' },
  tdNum: { padding: '7px 10px', textAlign: 'right', borderBottom: '1px solid #F0E9E0' },
  tdCentro: { padding: '7px 10px', textAlign: 'center', borderBottom: '1px solid #F0E9E0' },
  filaSinDato: { background: '#FBF6E9' },
  tagSinDato: { fontSize: '10px', fontWeight: 600, color: '#B8862E', background: '#F9F0DD', padding: '2px 8px', borderRadius: '10px' },
  notaReagendada: { fontSize: '10px', color: '#B8862E', marginTop: '2px' },
  filaClickable: { cursor: 'pointer' },
  flechaExpandir: { color: '#8A7690', fontSize: '10px', marginRight: '4px' },
  celdaDetalle: { padding: '10px 10px 14px 28px', background: '#F5F3F0', borderBottom: '1px solid #F0E9E0' },
  tablaDetalle: { width: '100%', borderCollapse: 'collapse', fontSize: '11.5px' },
  thDetalle: { textAlign: 'left', padding: '5px 8px', color: '#8A7690', fontSize: '10px', textTransform: 'uppercase' },
  thNumDetalle: { textAlign: 'right', padding: '5px 8px', color: '#8A7690', fontSize: '10px', textTransform: 'uppercase' },
  thCentroDetalle: { textAlign: 'center', padding: '5px 8px', color: '#8A7690', fontSize: '10px', textTransform: 'uppercase' },
  tdDetalle: { padding: '4px 8px' },
  tdNumDetalle: { padding: '4px 8px', textAlign: 'right' },
  tdCentroDetalle: { padding: '4px 8px', textAlign: 'center' },
  filaDetalleFalla: { background: '#FDF3F1' },
};